import React from 'react';

function accuracyClass(pct) {
  if (pct === null || pct === undefined) return 'text-text-muted';
  if (pct < 50) return 'text-red';
  if (pct < 70) return 'text-amber';
  return 'text-green';
}

export default function QuestionStats({ stats }) {
  const safe = stats || {};
  const total_attempted = safe.total_attempted ?? 0;
  const total_correct = safe.total_correct ?? 0;
  const accuracy_pct = safe.accuracy_pct;
  const attempted_today = safe.attempted_today ?? 0;
  const streak = safe.streak ?? 0;

  const cards = [
    { label: 'Attempted', value: total_attempted, cls: 'text-text-primary' },
    { label: 'Correct', value: total_correct, cls: 'text-text-primary' },
    {
      label: 'Accuracy',
      value: accuracy_pct != null ? `${accuracy_pct}%` : '—',
      cls: accuracyClass(accuracy_pct),
    },
    { label: 'Today', value: attempted_today, cls: 'text-text-primary' },
    { label: 'Streak', value: streak, cls: 'text-text-primary' },
  ];

  return (
    <div className="grid grid-cols-5 gap-sp-3 mb-sp-5">
      {cards.map((c) => (
        <div
          key={c.label}
          className="bg-bg-card rounded-r-xl border border-border-soft px-sp-4 py-sp-3"
        >
          <p className="text-xs font-medium text-text-muted mb-sp-1">{c.label}</p>
          <p className={`text-2xl font-bold ${c.cls}`}>{c.value}</p>
        </div>
      ))}
    </div>
  );
}
